export const KENNEY_FUTURE_NARROW_FONT_NAME = 'Kenney-Future-Narrow';
